import type {Mapper} from 'framework';
import type {CompleteWorkoutResult, PersonalRecordHit} from '../../domain/workout';
import type {CompleteWorkoutDto} from '../dto/workout.dto';
import type {WorkoutDtoToWorkoutMapper} from './workout-dto-to-workout.mapper';

export class CompleteWorkoutDtoToResultMapper
  implements Mapper<CompleteWorkoutDto, CompleteWorkoutResult>
{
  constructor(private readonly workoutMapper: WorkoutDtoToWorkoutMapper) {}

  transform(dto: CompleteWorkoutDto): CompleteWorkoutResult {
    return {
      workout: this.workoutMapper.transform(dto.workout),
      personalRecords: dto.personalRecords.map(
        (hit): PersonalRecordHit => ({
          exerciseId: hit.exerciseId,
          kind: hit.kind,
          value: hit.value,
          reps: hit.reps,
        }),
      ),
    };
  }
}
